export const TOGGLE_VISIBILITY_ACTION = 'Action.ToggleVisibility';
export const SHOW_CARD_ACTION = 'Action.ShowCard';
export const OPEN_URL_ACTION = 'Action.OpenUrl';
